import type { ReactNode } from 'react';
import styled from '@emotion/styled';

import type { BreadcrumbsProps } from '@hotjar/hotsauce';
import { Breadcrumbs, tokens } from '@hotjar/hotsauce';

interface Props {
  title: string;
  actions?: ReactNode;
  subheader?: ReactNode;
  breadcrumbItems?: BreadcrumbsProps['children'];
}

const S = {
  Container: styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: ${tokens.spacer.x4};
  `,
  ContentContainer: styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
  `,
  Title: styled.h3`
    ${tokens.text('header3')};

    margin-right: ${tokens.spacer.x3};
  `,
  Spacer: styled.span`
    flex: 1 1 auto;
  `,
  ActionsContainer: styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: ${tokens.spacer.x2};
    justify-content: flex-end;
  `,
  Subheader: styled.div`
    margin-top: ${tokens.spacer.x1};
  `,
};

/**
 * @deprecated use Hotsauce
 * [`<PageHeader />`](https://storybook.hotjar.com/?path=/docs/components-pageheader--page-header) instead
 * @see packages/hotsauce/src/components/PageHeader/PageHeader
 */
export const PageHeader = ({ title, actions, breadcrumbItems, subheader }: Props): JSX.Element => {
  return (
    <S.Container>
      {breadcrumbItems && <Breadcrumbs>{breadcrumbItems}</Breadcrumbs>}
      <S.ContentContainer>
        <S.Title>{title}</S.Title>
        {actions && (
          <>
            <S.Spacer />
            <S.ActionsContainer>{actions}</S.ActionsContainer>
          </>
        )}
      </S.ContentContainer>
      {subheader && <S.Subheader>{subheader}</S.Subheader>}
    </S.Container>
  );
};
